// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__19wsP","clinicsSelect":"TableHeading_clinicsSelect__2niTo"};